// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-aff-apply-online-tsx": () => import("./../../../src/pages/aff/apply-online.tsx" /* webpackChunkName: "component---src-pages-aff-apply-online-tsx" */),
  "component---src-pages-privacy-policy-texas-txcso-tsx": () => import("./../../../src/pages/privacy-policy/texas-txcso.tsx" /* webpackChunkName: "component---src-pages-privacy-policy-texas-txcso-tsx" */)
}

